import React from 'react';
import { useDragLayer, XYCoord } from 'react-dnd';
import { CardDragPreview } from './CardDragPreview';
import { DraggableItemType } from './DraggableItemTypes';

const layerStyles: React.CSSProperties = {
  position: 'fixed',
  pointerEvents: 'none',
  zIndex: 100,
  left: 0,
  top: 0,
  width: '100%',
  height: '100%',
};

export interface CustomDragLayerProps {

}

export const CustomDragLayer: React.FC<CustomDragLayerProps> = (props: CustomDragLayerProps) => {
  const { itemType, isDragging, item, initialOffset, currentOffset } = useDragLayer(monitor => ({
    item: monitor.getItem(),
    itemType: monitor.getItemType(),
    initialOffset: monitor.getInitialSourceClientOffset(),
    currentOffset: monitor.getSourceClientOffset(),
    isDragging: monitor.isDragging(),
  }));

  if (!isDragging) {
    return null;
  }

  return (
    <div style={layerStyles}>
      <div style={getItemStyles(initialOffset, currentOffset)}>
        {renderItem(itemType as DraggableItemType, item)}
      </div>
    </div>
  );
};

function renderItem(itemType: DraggableItemType, item: any) {
  switch (itemType) {
    case DraggableItemType.Card:
      return <CardDragPreview content={item.content}/>;
    default:
      return null;
  }
}

function getItemStyles(initialOffset: XYCoord | null, currentOffset: XYCoord | null) {
  if (!initialOffset || !currentOffset) {
    return {
      display: 'none',
    };
  }

  const { x, y } = currentOffset;
  const transform = `translate(${x}px, ${y}px)`;
  return {
    transform,
    WebkitTransform: transform,
  };
}
